var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"pa-0":""}},[_c('v-card-title',{staticStyle:{"color":"#000","background":"#9FA8DA"}},[_c('h3',[_vm._v("Guidelines")])]),_c('v-card-text',[_c('p',{staticClass:"headline",staticStyle:{"text-align":"justify"}}),_c('span',{staticStyle:{"color":"#000"},domProps:{"innerHTML":_vm._s(_vm.guidelines)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }